module.exports = __webpack_public_path__ + "static/img/新媒体实验室.bd1678bf.png";